import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from "react-datepicker";
import { addMonths, isBefore, isAfter, min,isSameDay } from 'date-fns'; // Import these functions
import {
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Button,
    FormFeedback
} from 'reactstrap';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getDivisionByCategoryService, getSelectSupplierCategoryService, getSelectSupplierPlant } from '../../VendorNeedForm/Actions';
import { SearchableSelectHookForm } from '../../../layout/HookFormInputs';
import { getEmployeeService, getProfileMasterListService, getSelectFormTypeAll } from '../actions';
import { API } from '../../../../config/constants';
import axiosHelper from '../../../../axiosHelper';
import LoaderCustom from '../../../common/LoaderCustom';
import ApprovalListData from './ApprovalListData';
import { apiErrors } from '../../../../helper';
import DayTime from '../../../common/DayTimeWrapper';

// Hardcoded data for dropdowns
const formTypes = [
    { value: "type1", label: "Type 1" },
    { value: "type2", label: "Type 2" },
];



const ApprovalList = () => {
    const history = useHistory();

    const {
        control,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
        register,
    } = useForm();

    const [submissions, setSubmissions] = useState([]);

    const [approvalMatrixData, setApprovaMatrixData] = useState(false)

    const [selectedCategory, setSelectedCategory] = useState([]);
    const [currencyScaleData, setCurrencyScaleData] = useState(null);
    const [formTypeAll, setFormTypeAll] = useState(null);
    const [employeeData, setEmployeeData] = useState(null);
    const [profileMasterData, setProfileMasterData] = useState(null);
    const [checkDivison, setCheckDivison] = useState(false);
    const [apiError, setApiError] = useState('');
    const [loading, setLoading] = useState(false);  // For button loading
    const [
        selectedPotentialSupplierListPlant,
        setSelectedpotentialSupplierListPlant,
    ] = useState([]);
    const [fromDate, setFromDate] = useState(null);

    const [toDate, setToDate] = useState(null);

    // useEffect(() => {
    //     // Set initial dates when component mounts
    //     const currentDate = new Date();
    //     setFromDate(currentDate);

    //     // Set initial To Date to 2 months ahead, but not beyond current date
    //     const twoMonthsAhead = new Date(currentDate);
    //     twoMonthsAhead.setMonth(currentDate.getMonth() + 1);
    //     setToDate(twoMonthsAhead > currentDate ? currentDate : twoMonthsAhead);
    // }, []);

    // const setToDateTwoMonthsAhead = (fromDate) => {
    //     const twoMonthsAhead = new Date(fromDate);
    //     twoMonthsAhead.setMonth(fromDate.getMonth() + 1);
    //     const currentDate = new Date();
    //     return twoMonthsAhead > currentDate ? currentDate : twoMonthsAhead;
    // };
    // const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);

    // const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);

    //  const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);

    useEffect(() => {
        // Set initial dates when component mounts
        const currentDate = new Date();
        const oneMonthLater = addMonths(currentDate, 1);
        
        setFromDate(currentDate);
        setToDate(min([oneMonthLater, new Date()])); // Ensure it's not after today
        
        // Set the form values
        setValue("fromDate", currentDate);
        setValue("toDate", min([oneMonthLater, new Date()]));
    }, []);

    const handleFromDateChange = (date) => {
        const currentDate = new Date();
        if (date && isBefore(date, currentDate)) {
            setFromDate(date);
            
            // Ensure To Date is not more than 1 month after From Date and not after current date
            const maxToDate = min([addMonths(date, 1), currentDate]);
            if (toDate && (isAfter(toDate, maxToDate) || isBefore(toDate, date))) {
                setToDate(maxToDate);
                setValue("toDate", maxToDate);
            }
        }
    };

    const handleToDateChange = (date) => {
        const currentDate = new Date();
        if (date && isBefore(date, currentDate) && (isSameDay(date, fromDate) || isAfter(date, fromDate))) {
            const maxToDate = min([addMonths(fromDate, 1), currentDate]);
            if (isBefore(date, maxToDate) || isSameDay(date, maxToDate)) {
                setToDate(date);
            } else {
                setToDate(maxToDate);
            }
        }
    };
    useEffect(() => {
        getSelectSupplierCategory()
        getSelectSupplierNeedFormPlant()
        getFormTypeAll()
        getEmployeeData()
        getProfileList()
    }, [])

    const getSelectSupplierCategory = (data) => {
        getSelectSupplierCategoryService(
            data?.IsExceptionalSupplier
        )
            .then((res) => {
                setSelectedCategory(res?.Data);
            })
            .catch(() => { });
    };
    const getSelectSupplierNeedFormPlant = () => {
        getSelectSupplierPlant()
            .then((res) => {
                setSelectedpotentialSupplierListPlant(res?.Data);
            })
            .catch(() => { });
    };
    const getFormTypeAll = () => {
        getSelectFormTypeAll()
            .then((res) => {
                setFormTypeAll(res?.Data);
            })
            .catch(() => { });
    };
    const getEmployeeData = () => {
        getEmployeeService()
            .then((res) => {
                setEmployeeData(res?.Data?.EmployeeMasterList);
            })
            .catch(() => { });
    };
    const getProfileList = () => {
        getProfileMasterListService()
            .then((res) => {
                setProfileMasterData(res?.Data?.ProfileMasterList);
            })
            .catch(() => { });
    };
    const renderListing = (label) => {
        if (label === "CategoryData") {
            return selectedCategory?.map((potentialSupplierData) => ({
                value: potentialSupplierData.Id,
                label: potentialSupplierData.Name,
            }));
        }
        if (label === "PlantData") {
            return selectedPotentialSupplierListPlant?.map((potentialSupplierData) => ({
                value: potentialSupplierData.Id,
                label: potentialSupplierData.PlantName,
            }));
        }
        if (label === "DivisionData") {
            return currencyScaleData?.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.Id,
                label: yearOfBuisnessIncorporation.Name,
            }));
        }
        if (label === "formTypeAll") {
            return formTypeAll?.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.ShortApprovalType,
                label: yearOfBuisnessIncorporation.ApprovalType,
            }));
        }
        if (label === "EmployeeData") {
            return employeeData?.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.EmployeeCode,
                label: yearOfBuisnessIncorporation.EmployeeName,
            }));
        }
        if (label === "ProfileData") {
            return profileMasterData?.map((yearOfBuisnessIncorporation) => ({
                value: yearOfBuisnessIncorporation.ProfileId,
                label: yearOfBuisnessIncorporation.ProfileName,
            }));
        }

    };
    const handleCategoryDivisionMaster = async (selectedCategoryId, emptyOther = true) => {
        const selectedCategoryCheckDivison = selectedCategory.find(category => category.Id == selectedCategoryId?.value);
        if (selectedCategoryCheckDivison) {
            setCheckDivison(selectedCategoryCheckDivison.IsDivision);
        }
        try {
            const currencyScaleResponse = await getDivisionByCategoryService(selectedCategoryId?.value);
            setCurrencyScaleData(currencyScaleResponse?.Data?.VendorCategory);
        } catch (error) {

        }

        if (emptyOther) {
            setValue("Division", null);
        }
    };
    const handleReset = () => {
        const resetFromDate = new Date();
        const resetToDate = new Date();
        resetToDate.setMonth(resetToDate.getMonth() - 1); // Reset to 2 months ahead

        reset({
            FormType: null,
            Category: null,
            Division: null,
            Plant: null,
            Profile: null,
            Employee: null,
            fromDate: resetFromDate, // Reset to default from date
            toDate: resetToDate, // Reset to default to date
        });
        setApprovaMatrixData(false);
        setCheckDivison(false);
        setApiError('');
        setSubmissions([]);
        setFromDate(resetFromDate);
        setToDate(resetToDate);
    };
    const onSubmit = async (data) => {
        setLoading(true);
        setApiError('');

        // Extract the values from the form fields
        const formTypeValue = data.FormType?.value || "";
        const categoryId = data.Category?.value || "";
        const divisionId = data.Division?.value || "";
        const plantCode = data.Plant?.value || "";
        const employeeCode = data.Employee?.value || "";
        const profileId = data.Profile?.value || "";

        // Check if at least one of the fields is selected
        if (!formTypeValue && !categoryId && !divisionId && !plantCode && !employeeCode && !profileId && !fromDate && !toDate) {
            setApiError('Please select at least one field.');
            setLoading(false);
            return; // Stop the submission
        }

        // Construct query parameters dynamically
        const params = {
            type: formTypeValue || undefined,
            categoryId: categoryId || undefined,
            plantCode: plantCode || undefined,
            profileId: profileId || undefined,
            employeeCode: employeeCode || undefined,
            divisionId: divisionId || undefined,
            fromDate: fromDate ? DayTime(fromDate).format('MM/DD/YYYY') : undefined,
            toDate: toDate ? DayTime(toDate).format('MM/DD/YYYY') : undefined,
        };

        // Create a URLSearchParams instance and append only defined parameters
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                queryParams.append(key, value);
            }
        });

        // Construct the full API URL
        const apiUrl = `${API.getApprovalMatrixListing}?${queryParams.toString()}`;

        try {
            // Make the API request using axiosHelper
            const res = await axiosHelper.get(apiUrl);

            if (res?.data?.Data?.length) {
                setApprovaMatrixData(true);
                setSubmissions(res?.data?.Data);  // Update the component with response data
            } else {
                setApprovaMatrixData(false);
                setSubmissions([]);
                setApiError('No data found.');  // Show error if no data found
            }
        } catch (error) {
            if (error.response.status === 401) {
                apiErrors(error)
            }
            setApiError('An error occurred while submitting the form.');
            // apiErrors(error); // Uncomment if you want to handle API errors globally
        } finally {
            setLoading(false);
        }
    };





    return (
        <>  {loading && <LoaderCustom customClass="simulation-Loader" />}
            <Container className="mt-4">
                <Row className="align-items-center mb-4">
                    <Col className="d-flex justify-content-between">
                        <h1>&nbsp;</h1>
                        <button
                            type="button"
                            className="user-btn Tour_List_Reset"
                            title="Reset Grid"
                            onClick={handleReset}  // Reset button functionality
                        >
                            <div className="refresh mr-0"></div>
                        </button>
                    </Col>
                </Row>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row form>
                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("FormType")}
                                label="Form Type"
                                rules={{ required: false }}
                                name="FormType"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("formTypeAll")}
                                // mandatory={true}
                                handleChange={(value) => {
                                    // handleCategoryDivisionMaster(value);
                                }}
                                errors={errors?.FormType}
                                disabled={false}
                            />
                        </Col>
                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("Employee")}
                                label="Employee"
                                rules={{ required: false }}
                                name="Employee"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("EmployeeData")}
                                // mandatory={true}
                                handleChange={(value) => {
                                    // handleCategoryDivisionMaster(value);
                                }}
                                errors={errors?.Employee}
                                disabled={false}
                            />
                        </Col>
                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("Profile")}
                                label="Profile"
                                rules={{ required: false }}
                                name="Profile"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("ProfileData")}
                                // mandatory={true}
                                handleChange={(value) => {
                                    // handleCategoryDivisionMaster(value);
                                }}
                                errors={errors?.Profile}
                                disabled={false}
                            />
                        </Col>


                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("Category")}
                                label="Category"
                                rules={{ required: false }}
                                name="Category"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("CategoryData")}
                                // mandatory={true}
                                handleChange={(value) => {
                                    handleCategoryDivisionMaster(value);
                                }}
                                errors={errors?.Category}
                                disabled={false}
                            />
                        </Col>
                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("Division")}
                                label="Division"
                                rules={{ required: checkDivison }}
                                name="Division"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("DivisionData")}
                                mandatory={checkDivison}
                                handleChange={(value) => {
                                    // handleSelectChange(value);
                                }}
                                errors={errors?.Division}
                                disabled={!checkDivison}
                            />
                        </Col>
                        <Col md={2}>
                            <SearchableSelectHookForm
                                {...register("Plant")}
                                label="Plant"
                                rules={{ required: false }}
                                name="Plant"
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                register={register}
                                options={renderListing("PlantData")}
                                // mandatory={true}
                                handleChange={(value) => {
                                    // handleSelectChange(value);
                                }}
                                errors={errors?.Plant}
                                disabled={false}
                            />
                        </Col>
                        <Col md={2}>
                <FormGroup>
                    <Label for="fromDate">From Date</Label>
                    <Controller
                        control={control}
                        name="fromDate"
                        render={({ field }) => (
                            <DatePicker
                                placeholderText="Select From Date"
                                selected={fromDate}
                                onChange={(date) => {
                                    handleFromDateChange(date);
                                    field.onChange(date);
                                }}
                                dateFormat="yyyy-MM-dd"
                                className="form-control"
                                isClearable
                                maxDate={new Date()}
                            />
                        )}
                    />
                </FormGroup>
            </Col>
            <Col md={2}>
                <FormGroup>
                    <Label for="toDate">To Date</Label>
                    <Controller
                        control={control}
                        name="toDate"
                        render={({ field }) => (
                            <DatePicker
                                placeholderText="Select To Date"
                                selected={toDate}
                                onChange={(date) => {
                                    handleToDateChange(date);
                                    field.onChange(date);
                                }}
                                dateFormat="yyyy-MM-dd"
                                className="form-control"
                                isClearable
                                minDate={fromDate}
                                maxDate={min([addMonths(fromDate, 1), new Date()])}
                            />
                        )}
                    />
                </FormGroup>
            </Col>
                        <Col md={2} className="d-flex pt-2">
                            <Button color="primary" className='mt-4' type="submit">Submit</Button>


                        </Col>
                    </Row>
                </form>
                {apiError && (
                    <div className="text-danger mt-3">{apiError}</div>
                )}
            </Container>

            {approvalMatrixData && <ApprovalListData submissions={submissions} />}
        </>



    );
};

export default ApprovalList;